import React from 'react';
import { SxProps, Theme } from '@mui/material';
import CarbonCareDateRangePicker from './CarbonCareDatePicker';
import type { DateRangePreset } from './CarbonCareDatePicker';

interface DateRangeSelectorProps {
  fromDate: Date | null;
  toDate: Date | null;
  onFromDateChange: (date: Date | null) => void;
  onToDateChange: (date: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  /** Quick-range rail beside the calendar. Pass [] to hide it. */
  presets?: DateRangePreset[];
  sx?: SxProps<Theme>;
}

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  minDate,
  maxDate,
  disabled,
  presets,
  sx,
}) => (
  <CarbonCareDateRangePicker
    fromDate={fromDate}
    toDate={toDate}
    onFromDateChange={onFromDateChange}
    onToDateChange={onToDateChange}
    minDate={minDate}
    maxDate={maxDate}
    disabled={disabled}
    presets={presets}
    sx={sx}
  />
);

export default DateRangeSelector;
